import React from 'react';
import Button from '../ui/Button';
import Icon from '../AppIcon';

export default function EmailWizardFrame({
  title,
  subtitle,
  steps,
  stepIndex,
  onClose,
  onBack,
  onNext,
  nextLabel = 'Continuer',
  nextDisabled = false,
  showBack = true,
  footerExtra,
  children,
  layout = 'modal',
  backLabel = 'Annuler',
}) {
  const current = steps[stepIndex];
  const isPage = layout === 'page';

  const shell = (
    <div
      className={`relative flex flex-col overflow-hidden bg-card ${
        isPage
          ? 'min-h-[calc(100vh-8rem)] w-full rounded-xl border border-border shadow-sm'
          : 'h-[90vh] w-full max-w-6xl rounded-xl shadow-elevation-3'
      }`}
    >
        <div className="flex shrink-0 items-center justify-between border-b border-border p-4">
          <div className="min-w-0">
            <h2 className="truncate text-lg font-semibold text-foreground">{title}</h2>
            {subtitle ? (
              <p className="truncate text-xs text-muted-foreground">{subtitle}</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 transition-smooth hover:bg-muted"
            aria-label="Fermer"
          >
            <Icon name="X" size={18} />
          </button>
        </div>

        <div className="shrink-0 border-b border-border bg-muted/20 px-4 py-3">
          <ol className="flex flex-wrap items-center gap-2 text-xs">
            {steps.map((step, i) => {
              const done = i < stepIndex;
              const active = i === stepIndex;
              return (
                <li key={step.id} className="flex items-center gap-2">
                  {i > 0 ? (
                    <span className="text-muted-foreground/50" aria-hidden>
                      /
                    </span>
                  ) : null}
                  <span
                    className={`rounded-full px-2.5 py-1 font-medium ${
                      active
                        ? 'bg-primary text-primary-foreground'
                        : done
                          ? 'bg-muted text-foreground'
                          : 'text-muted-foreground'
                    }`}
                  >
                    {step.label}
                  </span>
                </li>
              );
            })}
          </ol>
          {current?.hint ? (
            <p className="mt-2 text-xs text-muted-foreground">{current.hint}</p>
          ) : null}
        </div>

        <div className={`min-h-0 flex-1 overflow-auto p-4 ${isPage ? 'pb-6' : 'pb-24'}`}>
          {children}
        </div>

        <div
          className={`flex flex-col gap-3 border-t border-border bg-card p-4 md:flex-row md:items-center md:justify-between ${
            isPage ? 'sticky bottom-0' : 'absolute bottom-0 left-0 right-0 shadow-elevation-2'
          }`}
        >
          <div className="min-w-0 flex-1">{footerExtra}</div>
          <div className="flex shrink-0 justify-end gap-2">
            {showBack && stepIndex > 0 ? (
              <Button type="button" variant="outline" size="sm" onClick={onBack}>
                Retour
              </Button>
            ) : (
              <Button type="button" variant="outline" size="sm" onClick={onClose}>
                {backLabel}
              </Button>
            )}
            <Button
              type="button"
              size="sm"
              iconName={stepIndex >= steps.length - 1 ? 'Save' : 'ChevronRight'}
              iconPosition={stepIndex >= steps.length - 1 ? 'left' : 'right'}
              onClick={onNext}
              disabled={nextDisabled}
            >
              {stepIndex >= steps.length - 1 ? nextLabel : 'Continuer'}
            </Button>
          </div>
        </div>
      </div>
  );

  if (isPage) return shell;

  return (
    <div className="fixed inset-0 z-[1150] flex items-center justify-center bg-black/50 p-2 md:p-4">
      {shell}
    </div>
  );
}
